<style>
.primary-exp {
  background-color: rgb(28,196,205);
  color: #fff;
}

.primary-exp:hover {
  background-color: rgb(22,170,178);
}


</style>
<template>
  <div>
    <v-card class="mx-auto" outlined>
      <v-expansion-panels   multiple>

        <!--تعريف قاعدة الرغبات -->
        <v-expansion-panel>
          <v-expansion-panel-header class="exp-header primary-exp">
            {{ $t("DEFINE_DESIRE_RULE") }}
            <v-spacer></v-spacer>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-alert v-if="showAlert" dense outlined type="error">
                {{ serverTranslate(errorMessages) }}
              </v-alert>

              <div class="red--text  font-weight-medium my-2">
                {{ $t("FEE_DESIRE_MESSAGE") }}
              </div>
              <v-row class="pt-4 align-center">
                <v-col cols="12" md="3">
                  <v-label class="font-weight-bold">
                    {{ $t("CUSTOM_NUMBER") }}
                  </v-label>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                      v-model.number="rule.customCount"
                      :label="$t('DESIRE_COUNT')"
                      :rules="[(v) => (rule.type !== 'custom' || v > 0) || $t('MUST_BE_POSITIVE')]"
                      dense
                      outlined
                      required
                      type="number"
                  />
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="save">{{ $t("SAVE") }}</v-btn>
                <v-btn class="white--text" color="darken3" @click="reset">{{ $t("CANCEL") }}</v-btn>
                <v-btn v-if="rule.id" color="error" dark @click="deleteRule">{{ $t("DELETE") }}</v-btn>
              </v-card-actions>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!--تعريف قاعدة الرسوم -->
        <v-expansion-panel style=" padding-top: 10px;">
          <v-expansion-panel-header class="exp-header primary-exp">
            {{ $t("APPLICATION_FEES") }}
            <v-spacer></v-spacer>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <ApplicationFeeRule/>
          </v-expansion-panel-content>
        </v-expansion-panel>

      </v-expansion-panels>

    </v-card>
    <pr-confirmDialog ref="confirm"></pr-confirmDialog>
  </div>
</template>

<script>
import serverTranslationsMixin from '@/mixins/serverTranslations.ts';
import globalMethodsMixin from '@/mixins/globalMethods.ts';
import ConfirmDialog from "@/components/shared/ConfirmDialog";
import ApplicationFeeRule from "@/components/modules/administration/SystemRules/ApplicationFeeRule.vue"

export default {
  name: 'FeesDesiresRules',
  components: {"pr-confirmDialog": ConfirmDialog, ApplicationFeeRule,},
  mixins: [serverTranslationsMixin, globalMethodsMixin],
  data() {
    return {
      valid: true,
      showAlert: false,
      errorMessages: '',
      rule: {
        type: '',
        customCount: null,
        id: null
      },
    };
  },
  created() {
    this.fetchDesireRule();
  },
  methods: {
    fetchDesireRule() {
      this.$http.get('/api/general_data/desire-rule/')
          .then(res => {
            const data = res.data.data || {};
            this.rule = {
              type: data.value1 === '1' ? '1' :
                  data.value1 === '*' ? '*' : 'custom',
              customCount: !isNaN(Number(data.value1)) ? Number(data.value1) : null,
              id: data.id || null,
            };
          })
          .catch(err => {
            this.showToasted('error', err.response?.data?.message || 'Fetch Error');
          });
    },
    reset() {
      this.rule = {type: '', customCount: null, id: null};
      this.$refs.form.resetValidation();
      this.fetchDesireRule()
    },
    save() {
      if (!this.$refs.form.validate()) return;
      const desiresNum = this.rule.customCount
      const payload = {desiresNum};
      const url = this.rule.id ? `/api/general_data/desire-rule/update/${this.rule.id}/` : '/api/general_data/desire-rule/create/';
      const method = this.rule.id ? 'put' : 'post';

      this.$http[method](url, payload)
          .then(res => {
            this.showToasted('success', res.data.message || 'Saved');
            this.fetchDesireRule();
          })
          .catch(err => {
            this.errorMessages = err.response?.data?.message || 'Unknown error';
            this.showAlert = true;
          });
    },
    deleteRule() {
      if (!this.rule.id) return;
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "CONFIRM_MESSAGES.DELETE_CONFIRMATION")
          .then(confirm => {
            if (!confirm) return;
            this.$http.delete(`/api/general_data/desire-rule/delete/${this.rule.id}/`)
                .then(res => {
                  this.showToasted("success", res.data.message);
                  this.reset();
                })
                .catch(err => {
                  this.showToasted("error", err.response?.data?.message);
                });
          });
    }
  },
};
</script>
